import { atom, selector } from "recoil";

export const colorState = atom({
  key : "main",
  default : "radial-gradient(circle, rgb(83, 173, 241) 0%, rgb(12, 73, 187) 100%)"
})
  
export const changeColorState = selector({
  key: "changeColorState",
  get: ({ get }) => {
    return get(colorState);
  },
  set: ({ set }, newValue) => {
    set(colorState, newValue);
  },
});

export const weatherData = atom({
  key : "data",
  default: [],
})